export const checkViewCount = {
    methods: {
        initViewCount(popup_id) {
            var parsedData = [];
            var viewCount = -1;
            var currentIndex = -1;

            if (localStorage.viewCountData != null) {
                parsedData =  JSON.parse(localStorage.viewCountData);

                for (var i= 0; i < parsedData.length; i++) {
                    if (parsedData[i]["link"] === window.location.href) {

                        if (parsedData[i][popup_id] === undefined) {
                            parsedData[i][popup_id] = 0;
                        }

                        viewCount = parsedData[i]["count"];
                        currentIndex = i;
                        break;
                    }
                }
            }

            if (currentIndex >= 0) {
                viewCount =  parseInt(parsedData[currentIndex][popup_id]) + 1;
                parsedData[currentIndex][popup_id] = viewCount;
            } else {

                viewCount = 1;
                parsedData.push(
                    {
                        "link": window.location.href,
                        [popup_id]: viewCount
                    })
            }

            localStorage.viewCountData = JSON.stringify(parsedData);
        },
        isShowPopup(popup_id)
        {
            let result = true;

            if (localStorage.viewCountData) {
                let array_data = JSON.parse(localStorage.viewCountData);

                if (array_data) {
                    array_data.forEach(function(item) {
                        if (item.link == window.location.href) {
                            if (item[popup_id] > 3) {
                                result = false;
                            }
                        }
                    });
                }
            }
            return result;
        }
    }
}





// WEBPACK FOOTER //
// ./resources/assets/js/mixins/checkViewCount.js